import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    width: 70,
    justifyContent: 'space-between',
  },
});
